import { useState } from 'react';
import type { Filter } from '../types';
import { useToggleFilter } from '../hooks/useFilters';

interface FilterCardProps {
  filter: Filter;
  guildId: string;
}

export default function FilterCard({ filter, guildId }: FilterCardProps) {
  const [isEnabled, setIsEnabled] = useState(filter.enabled);
  const toggleFilter = useToggleFilter(guildId);

  const handleToggle = async () => {
    const newState = !isEnabled;
    setIsEnabled(newState);

    try {
      await toggleFilter.mutateAsync({
        filterId: filter.id,
        enabled: newState,
      });
    } catch (error) {
      // 실패 시 원래 상태로 되돌림
      setIsEnabled(!newState);
      alert('필터 설정 변경에 실패했습니다');
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <h3 className="text-lg font-semibold text-gray-900">{filter.name}</h3>
        <button
          onClick={handleToggle}
          disabled={toggleFilter.isPending}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
            isEnabled ? 'bg-gradient-to-r from-[#FF7A7A] to-[#DD8DFF]' : 'bg-gray-200'
          } ${toggleFilter.isPending ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              isEnabled ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>

      <p className="text-sm text-gray-600 mb-4">{filter.description}</p>

      <div className="flex items-center justify-between">
        <span
          className={`text-xs font-medium px-2 py-1 rounded ${
            isEnabled
              ? 'bg-green-100 text-green-800'
              : 'bg-gray-100 text-gray-800'
          }`}
        >
          {isEnabled ? '활성화' : '비활성화'}
        </span>
      </div>
    </div>
  );
}
